import { render, staticRenderFns } from "./DocumentCenter.vue?vue&type=template&id=48e6f6f8&"
import script from "./DocumentCenter.vue?vue&type=script&lang=js&"
export * from "./DocumentCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports